export const buildGetBillingDetailsApiConfig = () => ({
    method: 'GET',
    url: '/api/billing/companies/billing-details',
});

export const buildPostBillingDetailsApiConfig = ({ data }) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { id, ...newData } = data;
    return {
        method: 'POST',
        url: '/api/billing/companies/billing-details',
        data: newData,
    };
};

export const buildEditBillingDetailsApiConfig = ({ data }) => {
    const {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        id, cnpj, taxNumber, countryCode, ...newData
    } = data;
    return {
        method: 'PUT',
        url: `/api/billing/companies/billing-details/${data.id}`,
        data: newData,
    };
};
